import {URL_CONFIG} from '@/url_config';

const BASE_URL = URL_CONFIG.mi_url

export const fetchResultsFromAPI = async(keywords, contexts) => {
    const reqData = {
        keywords: keywords,
        contexts: contexts
    }
    let res = []
    try {
        // const fetch_url = 'https://tool.talans.cn/api/data_parallel_match_org'
        const fetch_url = 'http://tls.talans.cn:30911/api/data_parallel_match_org'
        const response = await fetch(fetch_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(reqData),
        });

        if (!response.ok) {
            throw new Error('Network fetchResultsFromAPI response was not ok');
        }

        const data = await response.json();
        if (data['error']) {
            console.error('Error uploading file:', data['error']);
            return
        }
        console.log("data", data)
        res = data['match_results']

    } catch (error) {
        console.error('Error uploading file:', error);
    }
    console.log("res", res)
    return res
};

export const fetchStructResultFromAPI = async(keywords, contexts) => {
    const reqData = {
        keywords: keywords,
        contexts: contexts
    }
    let res = []
    try {
        const response = await fetch(`${BASE_URL}/api/data_struct_match`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(reqData),
        });

        if (!response.ok) {
            throw new Error('Network fetchResultsFromAPI response was not ok');
        }

        const data = await response.json();
        if (data['error']) {
            console.error('Error uploading file:', data['error']);
            return
        }
        console.log("data", data)
        res = data['match_results']

    } catch (error) {
        console.error('Error uploading file:', error);
    }
    console.log("res", res)
    return res
};



export const fetchMatchData = async(keywords, contexts) => {
    const reqData = {
        keywords: keywords,
        context: contexts
    }
    let res = []
    try {
        const response = await fetch(`${BASE_URL}/mi_ai/data_match`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(reqData),
        });

        if (!response.ok) {
            console.warn('Network fetchMatchData response was not ok');
            return res
        }

        const data = await response.json();
        if (!data) {
            console.warn('fetchMatchData res empty');
            return res
        }
        if (data['error']) {
            console.warn('Error fetchMatchData:', data['error']);
            return res
        }
        res = data

    } catch (error) {
        console.error('Error uploading file:', error);
    }
    return res
};


export const commitMatchDataTask = async(fileKey, rootKey, fileHash, taskConfig, context) => {
    const reqData = {
        tasks_prompt: taskConfig,
        batch_context: context,
        file_key: fileKey,
        root_key: rootKey,
        file_hash: fileHash
    }
    let res = []
    try {
        const response = await fetch(`${BASE_URL}/mi_ai/data_match/commit_task_custom`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(reqData),
        });

        if (!response.ok) {
            console.warn('Network commitMatchDataTask response was not ok');
            return res
        }

        const data = await response.json();
        if (!data) {
            console.warn('fetchMatchData res empty');
            return res
        }
        if (data['error']) {
            console.warn('Error fetchMatchData:', data['error']);
            return res
        }
        res = data

    } catch (error) {
        console.error('Error uploading file:', error);
    }
    return res
};


